import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';

const PolicyholderAlreadyExists = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get existent policyholder full name from navigation state
  const existentPolicyholderFullName = location.state?.existentPolicyholderFullName;

  useEffect(() => {
    // Redirect to home if no data
    if (!existentPolicyholderFullName) {
      navigate('/');
    }
  }, [existentPolicyholderFullName, navigate]);

  if (!existentPolicyholderFullName) {
    return null; // Will redirect in useEffect
  }

  const handleBackToHome = () => {
    navigate('/');
  };

  const handleContactHelp = () => {
    window.location.href = 'mailto:webmaster@ri-net.com';
  };

  return (
    <div className="container">
      <Card>
        <div className="grid">
          <div className="col-12">
            <h1 className="text-primary text-4xl font-bold mb-4">Policyholder Already Registered</h1>
            
            <Message 
              severity="warn" 
              style={{ marginBottom: '2rem' }}
              content={
                <div>
                  <h3 className="mb-3">Registration Not Available</h3>
                  <p className="mb-2">
                    This policy has already been registered by <strong>{existentPolicyholderFullName}</strong>.
                  </p>
                  <p className="mb-2">
                    Only the original registrant can add additional users to this policy.
                  </p>
                  <p>
                    Please contact <strong>{existentPolicyholderFullName}</strong> to request user access, 
                    or contact our Help Desk for assistance.
                  </p>
                </div>
              }
            />
            
            <div className="mb-4">
              <p className="line-height-3">
                If you believe this is an error or if you need assistance, please contact our Help Desk:
                {' '}<strong>
                  <a href="mailto:webmaster@ri-net.com" className="text-primary">webmaster@ri-net.com</a>
                  {' '}or call 818-382-1007, Monday to Friday, 8:00 a.m. to 4:00 p.m.
                </strong>
              </p>
            </div>
            
            <div className="flex gap-3">
              <Button
                label="Back to Start"
                severity="warning"
                onClick={handleBackToHome}
              />
              <Button
                label="Contact Help Desk"
                severity="secondary"
                onClick={handleContactHelp}
              />
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default PolicyholderAlreadyExists;
